const Validation = validationInput => {
	const {
		personName,
		personNamete,
		shortBio,
		shortBiote,
		// wikipediaURL,
		// file,
		// spouse,
	} = validationInput
	const errArr = {}
	if (!personName) {
		errArr.personName = 'personName field is mandatory'
	}

	if (!personNamete) {
		errArr.personNamete = 'personNamete field is mandatory'
	}

	if (!shortBio) {
		errArr.shortBio = 'short bio  of the person is mandatory'
	}

	if (!shortBiote) {
		errArr.shortBiote = 'short biote  of the person is mandatory'
	}

	// if (!wikipediaURL) {
	// 	errArr.wikipediaURL = 'this field is mandatory'
	// }
	// // if (wikipediaURL !== 'http://www\\.facebook.com\\/(.+)|https://www\\.facebook\\.com\\/(.+)') {
	// // 	errArr.wikipediaURL = 'please enter valid url'
	// // }

	// if (!file) {
	// 	errArr.file = 'image of the person is mandatory'
	// }

	// if (!spouse) {
	// 	errArr.spouse = 'please enter name'
	// }

	return errArr
}

export default Validation
